import { render, staticRenderFns } from "./Styling.vue?vue&type=template&id=3501de97&scoped=true&"
import script from "./Styling.vue?vue&type=script&lang=js&"
export * from "./Styling.vue?vue&type=script&lang=js&"
import style0 from "./Styling.vue?vue&type=style&index=0&id=3501de97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3501de97",
  null
  
)

export default component.exports